const SwiperOptions = {
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 30,
    loop: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    breakpoints: {
        1025: {
            slidesPerView: 1,
            spaceBetween: 30
        },
        769: {
            slidesPerView:1,
            spaceBetween: 30
        }
    }
};

const SwiperOptionsAlt = {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    }
};

const SwiperOptionsBanner = {
    slidesPerView: 1,
    spaceBetween: 0,
    effect: 'fade',
    loop: true,
    autoplay: {
        delay: 5000
    }
};

export { SwiperOptions, SwiperOptionsAlt, SwiperOptionsBanner };
